import { useCallback, useState } from "react";

const TOUR_STORAGE_KEY = "hr-payroll-by-period-tour-completed";

export function usePayrollByPeriodTour() {
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);

  const hasCompletedTour = () => {
    if (typeof window === "undefined") return false;
    return localStorage.getItem(TOUR_STORAGE_KEY) === "true";
  };

  const startTour = useCallback(() => {
    setRun(true);
    setStepIndex(0);
  }, []);

  const stopTour = useCallback(() => {
    setRun(false);
    if (typeof window !== "undefined") {
      localStorage.setItem(TOUR_STORAGE_KEY, "true");
    }
  }, []);

  const handleJoyrideCallback = useCallback(
    (data: { status?: string; type?: string; index?: number }) => {
      if (data.index !== undefined) setStepIndex(data.index);
      if (
        data.status === "finished" ||
        data.status === "skipped" ||
        data.type === "tour:end"
      ) {
        stopTour();
      }
    },
    [stopTour],
  );

  return {
    run,
    stepIndex,
    startTour,
    stopTour,
    hasCompletedTour: hasCompletedTour(),
    handleJoyrideCallback,
  };
}
